var Tabs;
(function (Tabs) {
    if (document.querySelector(".paragraph--type--tab") !== null) {
        __once('.paragraph--type--tab', () => {
            const myTabs = document.querySelectorAll("ul.nav-tabs > li");
            const TABS_COUNT = myTabs.length;
            const CONTROLLER_DISABLED_CLASS = 'glide__arrow--disabled';
            const MEDIA_BREAKPOINT_MD = 768;
            function myTabClicks(tabClickEvent) {
                if (tabClickEvent.currentTarget !== tabClickEvent.target) {
                    for (var i = 0; i < TABS_COUNT; i++) {
                        myTabs[i].classList.remove("active");
                        myTabs[i].classList.remove("glide__slide--active");
                    }
                    if (!tabClickEvent.target) {
                        const tabActive = document.querySelector("ul.nav-tabs > li.glide__slide--active a");
                        const myContentPanes = document.querySelectorAll(".tab-pane");
                        for (i = 0; i < myContentPanes.length; i++) {
                            myContentPanes[i].classList.remove("active");
                        }
                        let activePaneId;
                        activePaneId = tabActive.getAttribute("tab-href");
                        const activePane = document.querySelector(activePaneId);
                        activePane.classList.add("active");
                    }
                    else {
                        const clickedTab = tabClickEvent.currentTarget;
                        clickedTab.classList.add("active");
                        clickedTab.classList.add("glide__slide--active");
                        tabClickEvent.preventDefault();
                        const myContentPanes = document.querySelectorAll(".tab-pane");
                        for (i = 0; i < myContentPanes.length; i++) {
                            myContentPanes[i].classList.remove("active");
                        }
                        const anchorReference = tabClickEvent.target;
                        const activePaneId = anchorReference.getAttribute("tab-href");
                        const activePane = document.querySelector(activePaneId);
                        activePane.classList.add("active");
                    }
                }
            }
            for (let ix = 0; ix < TABS_COUNT; ix++) {
                myTabs[ix].addEventListener("click", myTabClicks);
            }
        });
    }
})(Tabs || (Tabs = {}));
